/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Page, { type IPageAttrs } from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import type Mithril from 'mithril';

export interface LoadingPageAttrs extends IPageAttrs {}

export default class LoadingPage extends Page<LoadingPageAttrs> {
	view(): Mithril.Children {
		return <LoadingIndicator />;
	}
}
